var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownBids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 983 1014",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 389.378,
    cy: 430.596,
    r: 210.62,
    stroke: "#143232",
    strokeWidth: 62
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 800.164,
    cy: 213.134,
    r: 138.134,
    stroke: "#143232",
    strokeWidth: 62
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M751.817 333.951V452.761C751.817 453.865 752.713 454.761 753.817 454.761H846.465C847.57 454.761 848.465 453.865 848.465 452.761V333.951M679.331 720.542C679.331 662.759 567.374 632.166 510.799 623.981C510.397 623.923 509.998 623.994 509.634 624.175C413.562 671.931 317.588 648.202 269.169 624.185C268.782 623.993 268.34 623.939 267.914 624.017C57.1881 662.713 35.2937 847.265 50.8415 936.396C51.0076 937.348 51.8298 938 52.7963 938H846.465C847.57 938 848.465 937.104 848.465 936V553.408C848.465 552.304 847.57 551.408 846.465 551.408H681.331C680.227 551.408 679.331 552.304 679.331 553.408V720.542Z",
    stroke: "#143232",
    strokeWidth: 62
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownBids);
export default __webpack_public_path__ + "static/media/dropdown-bids.4ebbaa8d22403dc23f415418008a863c.svg";
export { ForwardRef as ReactComponent };